import React from 'react';
import BaseItem from '../../BaseItem';
import {Utils, MetaData} from '../../../importer';
import Radium from 'radium';

class Generic_RadioGroup extends BaseItem
{
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);

        if (Utils.IsTrue(this.props.onGetModelValue('Checked'))) {
            this.props.onSetState({
                MergeWithCurrentState : true,
                Variations : {
                    Checked : 'Checked'
                }
            })
        }
    }    
    componentDidMount() {
        super.componentDidMount();
        this.props.onRegisterToModel('Checked', {id : Utils.Id(), consumer : this.CheckStateChanged.bind(this)});
    }
    CheckStateChanged() {
        this.props.onSetState({
            MergeWithCurrentState : true,
            Variations : {
                Checked : Utils.IsTrue(this.props.onGetModelValue('Checked')) ? 'Checked' : null
            }
        })
    }
    onChange(e) {
        const isChecked = Utils.IsTrue(e.target.checked);
        this.props.onSetModelValue('Checked', isChecked);
    }
    onFocus(e) {
        if (window.AppState) {
            window.AppState.Designer.SetEditingText(true);;
        }
        this.props.onSetState({
            MergeWithCurrentState : true,
            Variations : {
                System : 'active'
            }
        })
    }
    onBlur(e) {
        if (window.AppState) {
            window.AppState.Designer.EditingText = false;
        }
        this.props.onUnsetState({
            MergeWithCurrentState : true,
            Variations : {
                System : 'active'
            }
        })
    }
    renderItem({style, props, events, rest}) {

        const isChecked = Utils.IsTrue(this.props.onGetModelValue('Checked'));
        const style_check = {
            borderRadius : '100%'
        };

        style_check.backgroundColor = Utils.JustGet(props.GenericOptions, '#fff', 'checkFill');
        
        const checkSize = 60; // super.GetProperty('checkSize', ['GenericOptions'], 50)
        style_check.width = Utils.px(checkSize, '%');
        style_check.height = Utils.px(checkSize, '%');

        return (
            <label style={{...style, display : 'inline-block', verticalAlign : 'middle', boxSizing : 'border-box'}} {...events}>
                <input type='radio' 
                    style={{
                        border: 0,
                        clip: 'rect(0 0 0 0)',
                        clippath: 'inset(50%)',
                        height: '1px',
                        margin: '-1px',
                        overflow: 'hidden',
                        padding: 0,
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    }} 
                    checked={isChecked} 
                    {...rest} 
                    onChange={this.onChange} 
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    disabled={this.props.IsStateActive('disabled', 'disabled')}
                    key='CheckInput'
                />
                <div style={{display : 'flex', alignItems : 'center', justifyContent : 'center', width : '100%', height : '100%'}}>
                    <div style={style_check}>
                        
                    </div>
                </div>
            </label>
        )
    }
}

export default Radium(Generic_RadioGroup);